import { Grid, Typography } from "@mui/material";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { from } from "rxjs";

import iconAlert from "@/assets/icons/icon-alert.svg";
import AppButton from "@/components/sitehub-ui/atoms/AppButton";
import { AppLandingTemplate } from "@/components/sitehub-ui/templates/AppLandingHorizontalTemplate";
import { logout } from "@/data_source/services/AccountServices";
import { classes } from "@/utils/css";

import styles from "./AppAccessNotConfigured.module.css";

export function AppAccessNotConfiguredView() {
  const { t } = useTranslation();

  const goToSignInHandler = useCallback(() => {
    from(logout()).subscribe();
  }, []);
  return (
    <AppLandingTemplate title={t("Access not configured")}>
      <Grid
        container
        direction="column"
        padding="46px 0px 72px 0px"
        alignItems="center"
        flexWrap="nowrap"
        maxHeight="326px"
        height="326px"
      >
        <img src={iconAlert} alt="access-not-configured" />
        <Typography
          className={classes(styles.label, styles.dark, styles.big)}
          margin="20px 0px 4px 0px"
        >
          {t("Access not configured")}
        </Typography>
        <Typography
          className={classes(styles.label)}
          textAlign="center"
          marginBottom="18px"
          maxWidth="420px"
        >
          {t(
            "Your account does not have access configured yet. Contact your administrator."
          )}
        </Typography>
        <AppButton
          disabled={false}
          label={t("Login")}
          style={{ paddingLeft: "32px", paddingRight: "32px" }}
          onClick={goToSignInHandler}
        />
      </Grid>
    </AppLandingTemplate>
  );
}
